import '../style.css';
import React from 'react';
import { MultiSelectProvider } from '../hooks/UseMultiSelect';
import Dropdown from './Dropdown';
import InlineSelect from '../../InlineSelect/InlineSelect';
var MultiSelect = function (props) {
    return React.createElement(MultiSelectProvider, { props: props },
        React.createElement("div", { className: "-rmsc ".concat(props.className || 'multi-select') },
            !props.inline && React.createElement(Dropdown, null),
            props.inline && React.createElement(InlineSelect, null)));
};
export default MultiSelect;



//////////////////
// WEBPACK FOOTER
// ./src/components/MultiSelect/multi-select/index.tsx
// module id = 1182
// module chunks = 0